import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import { useDebounce } from "../../../hooks/useDebounce";
import { adaptInsumoByEvaluacionArray, GET_INSUMOS_VISITA_BY_EVALUACION } from "../../../data/graphQL/queries/MisVisitas/getInsumosIndicacion";

const useGetInsumos = (idEvaluacion) => {
  const [insumos, setInsumos] = useState([]);
  const [filterStatus, setFilterStatus] = useState('');
  const [nombreInsumoSelected, setNombreInsumoSelected] = useState('');

  const debouncedFilterValue = useDebounce(filterStatus, 800);

  const [getInsumos, { data: insumosResults, loading: insumosLoading }] = 
      useLazyQuery(GET_INSUMOS_VISITA_BY_EVALUACION, {
        fetchPolicy: 'network-only'
      });

	useEffect(() => {
		if (!insumosResults) return;
    const list = adaptInsumoByEvaluacionArray(insumosResults.allInsumosVisitaByIdEvaluacion);
    setInsumos(Array.isArray(list) ? list : []);
	}, [insumosResults]);  

  // 🔹 Carga inicial (trae todo)
  useEffect(() => {
    if (!idEvaluacion) return;

    getInsumos({
      variables: {
        idEvaluacion,
        where: null
      }
    });
  }, [idEvaluacion]);

  // 🔹 Filtrado
  useEffect(() => {
    if (!idEvaluacion) return;
    if (!debouncedFilterValue.trim()) return;

    getInsumos({
      variables: {
        idEvaluacion,
        where: {
          descripcion: { contains: debouncedFilterValue }
        }
      }
    });
  }, [debouncedFilterValue, idEvaluacion]);

  return {
    insumos: insumos || [],
    nombreInsumoSelected,
    filterStatus,
    insumosLoading,
    setFilterStatus,
    setNombreInsumoSelected
  };
};

export default useGetInsumos;